import ko from 'knockout';
import templateMarkup from 'raw-loader!./developer-portal-container-view.html';


function DeveloperPortalContainerView(params) {

  var self = this;

  self.dataProvider = params.dataProvider;
  self.route = params.route;
  self.view = self.route().view;

  self.appsMenu = ko.observableArray([]);

}

DeveloperPortalContainerView.prototype.dispose = function () {
};

export default {
  viewModel: DeveloperPortalContainerView,
  template: templateMarkup
};

